import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    CHARTS_LOAD,
    ChartsLoadAction,
    ChartsLoadApiNormalizedResponse,
    chartsLoadApi,
} from "@/mk2/apps/strollers/containers/Charts/Charts.actions";
import { XHRAction, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { strollers_api_v2_chart_url } from "@/mk/urls/functions";

const logger = getLogger("strollers/Charts.sagas");

interface LoadApiResponse {
    body: {
        entities: ChartsLoadApiNormalizedResponse["entities"];
        result: ChartsLoadApiNormalizedResponse["result"];
    };
}

function* load({ xhr, filter }: ChartsLoadAction & XHRAction) {
    yield put(chartsLoadApi.request(filter));

    try {
        const response: LoadApiResponse = yield call(() =>
            xhr.get(strollers_api_v2_chart_url({ ...filter })),
        );
        yield put(
            chartsLoadApi.success(filter, {
                entities: response.body.entities,
                result: response.body.result,
            }),
        );
    } catch (error) {
        logger.error(error);
        yield put(chartsLoadApi.failure(filter, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(CHARTS_LOAD, load)]);
}
